import { Column, Tile } from '@codeparva/ui-components-library';
import React from 'react';
import { navigate } from 'gatsby';
import { FontAwesomeIcon } from '../../../../../utilities/iconLoader/FontAwesomeIcon';
import { IconsSize } from '../config';
import { SelectLocationsTypes } from '../SelectLocationsTypes';
import { NavBarFacilityDetailsHelper } from '../../../../sitewide/components/NavBar/helpers/NavBarFacilityDetailsHelper';
import { getPayRentUrl as getUrl } from './cookieHelpers';

export const SelectLocationCards = ({
  location,
  dataFrom,
  componentClicked,
}: SelectLocationsTypes.ILocations) => {
  const {
    attributes: {
      location_city,
      location_state,
      facility_sms_id,
      location_contact_details: {
        location_phone_number,
        location_google_maps_url,
      },
    },
  } = location;
  const phoneNumberRedirect = NavBarFacilityDetailsHelper(
    location_phone_number
  );
  const getPayRentUrl = getUrl(facility_sms_id);
  const handleClick = () => {
    switch (dataFrom) {
      case 'payrent':
        navigate(
          `/${location_state.toLowerCase()}/${location_city.toLowerCase()}/${getPayRentUrl}`,
          {
            state: { facility_sms_id: facility_sms_id },
          }
        );
        break;
      case 'reserve':
      case 'viewrates':
      case 'rent':
      case 'locations':
        navigate(
          `/${location_state.toLowerCase()}/${location_city.toLowerCase()}/view-rates`,
          {
            state: {
              clickedComponent: componentClicked,
            },
          }
        );
        break;
      case 'contactus':
        navigate(
          `/${location_state.toLowerCase()}/${location_city.toLowerCase()}/contact`
        );
        break;
      case 'storagetips':
        navigate('/storage-tips');
        break;
      default:
        break;
    }
  };
  return (
    <div
      className="locationsDiv is-flex is-flex-direction-row is-justify-content-center is-align-content-center"
      onClick={handleClick}
    >
      <Column className="locationsDivColumn is-flex is-flex-direction-row is-justify-content-center is-align-content-center">
        <Tile kind="ancestor" className="ancestorTile">
          <Tile kind="parent" className="ParentTile">
            <Tile kind="child" className="childTileOne">
              <div className="has-text-center childOneDiv">
                <a
                  href={location_google_maps_url}
                  rel="noreferrer"
                  target="_blank"
                  className="has-text-primary"
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  <FontAwesomeIcon
                    iconClassName={'FaMapMarkerAlt'}
                    iconContextProps={{
                      className: `has-text-primary`,
                      style: {
                        fontSize: IconsSize,
                      },
                    }}
                  />
                </a>
              </div>
            </Tile>
            <Tile kind="child" className="childTileTwo">
              <h5 className="tileContent has-text-black">
                {location_state.replace(/_/g, ' ')} ,{' '}
                {location_city.replace(/_/g, ' ')}
              </h5>
            </Tile>
            <Tile kind="child" className="childTileThree">
              <div className="has-text-center childThreeDiv">
                <a
                  href={phoneNumberRedirect}
                  rel="noreferrer"
                  className="has-text-primary"
                  onClick={e => {
                    e.stopPropagation();
                  }}
                >
                  <FontAwesomeIcon
                    iconClassName={'FaPhoneAlt'}
                    iconContextProps={{
                      className: `has-text-primary`,
                      style: {
                        fontSize: IconsSize,
                      },
                    }}
                  />
                </a>
              </div>
            </Tile>
          </Tile>
        </Tile>
      </Column>
    </div>
  );
};
